export const UPLOAD_QUEUE_CONFIG = {
    MAX_CONCURRENT: 3,
    ANALYSIS_START_DELAY_MS: 1000,
    ANALYSIS_POLL_INTERVAL_MS: 1000,
    ANALYSIS_TOAST_CLOSE_DELAY_MS: 5000
};

export const ANALYSIS_STATUS = {
    RUNNING: 'running',
    IDLE: 'idle'
};

export const RESIZE_CONFIG = {
    MAX_SIDE_PX: 2000,
    JPEG_QUALITY: 0.85
};

export const CONCURRENCY_CONFIG = {
    MOBILE_MAX: 1,
    HIGH_RAM_GB: 8,
    MID_RAM_GB: 4,
    HIGH_RAM_CONCURRENCY: 10,
    MID_RAM_CONCURRENCY: 4,
    DESKTOP_CORE_FALLBACK: 4,
    DESKTOP_CONCURRENCY: 4,
    DEFAULT_CONCURRENCY: 2
};

export function applyUploadsPolicy(policy = {}) {
    if (!policy || typeof policy !== 'object') return;
    if (policy.max_concurrent != null) {
        const val = Math.max(1, Math.min(10, Number(policy.max_concurrent)));
        if (!Number.isNaN(val)) {
            UPLOAD_QUEUE_CONFIG.MAX_CONCURRENT = val;
        }
    }
}

export function applyResizePolicy(policy = {}) {
    if (!policy || typeof policy !== 'object') return;
    if (policy.max_side_px != null) {
        const val = Math.max(1, Number(policy.max_side_px));
        if (!Number.isNaN(val)) {
            RESIZE_CONFIG.MAX_SIDE_PX = val;
        }
    }
    if (policy.jpeg_quality != null) {
        let val = Number(policy.jpeg_quality);
        if (!Number.isNaN(val)) {
            if (val > 1) val = val / 100;
            val = Math.max(0.1, Math.min(1, val));
            RESIZE_CONFIG.JPEG_QUALITY = val;
        }
    }
}
